export default [
  {
    path: '/relatorios',
    name: 'Relatorios',
    component: () => import('@/pages/relatorios/Relatorios'),
    children: [
      /* Financiamento */
      {
        path: 'colaborador-usuario',
        name: 'ColaboradorUsuario',
        meta: {
          descricao: 'Colaborador x Usuário'
        },
        component: () => import('@/pages/relatorios/ColaboradorUsuario')
      },
      {
        path: 'desempenho',
        name: 'Desempenho',
        meta: {
          descricao: 'Desempenho'
        },
        component: () => import('@/pages/relatorios/Desempenho')
      },
    ]
  }
]
